export default {
  team: {
    type: 'object',
    required: true,
    properties: {
      location: {
        type: 'string',
        required: false,
      },
      type: {
        type: 'string',
        required: false,
      },
      expectedStructure: {
        type: 'array',
        maxSize: 30,
        required: true,
        forEach: {
          type: 'object',
          _divisible: false,
          properties: {
            positionId: {
              type: 'enum',
              required: true,
            },
            technologyId: {
              type: 'enum',
              required: {
                value: true,
                when: [
                  {
                    '$.positionId': {
                      in: ['47', 47], // Only for SOFTWARE_ENGINEER
                    },
                  },
                ],
              },
            },
            competencyLevel: {
              type: 'enum',
              required: true,
            },
            requiredRole: {
              type: 'enum',
              required: true,
            },
            requiredFte: {
              type: 'number',
              required: true,
              minValue: {
                value: '0.1',
                message: 'Min value must not be less than 0.1.',
              },
              regex: {
                value: /^((0|[1-9][0-9]*)(\.[0-9]+)?|\.[0-9]+)$/,
                message: 'Invalid number.',
              },
            },
            description: {
              type: 'string',
              required: false,
              maxSize: { value: 255, message: 'Description must be less than 255 characters.' },
            },
          },
        },
      },
    },
  },
};
